import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/store/configureStore";
import { getPcsEventInstancesAsync } from "../../../app/slices/pcsEventSlice";
import { useEffect, useState } from "react";
import { ApiRequestStatus } from "../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { MESSAGE_PROCESSING_DETAILS } from "../../../app/utils/constant";
import { PcsEventInstanceDto } from "../../../app/models/events/pcsEventInstanceDto";
import { getLocalDateInString } from "../../../app/utils/util";

export default function EventsInstanceCredits() {

    const dispatch = useAppDispatch();
    const [eventId,] = useState(new URLSearchParams(window.location.search).get("eventId"));

    useEffect(() => {
        eventId && dispatch(getPcsEventInstancesAsync(eventId));
    }, [eventId, dispatch]);

    const { pcsEventInstances, getPcsEventInstancesStatus } = useAppSelector(state => state.pcsEvent);

    usePortalScreen(portalScreenContext('EventsInstanceCredits'), undefined, !(getPcsEventInstancesStatus === ApiRequestStatus.Pending));

    if (getPcsEventInstancesStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <Box sx={{ width: '100%' }} component={Paper}>

        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell><b>Start Date</b></TableCell>
                        <TableCell><b>Event Instance Description</b></TableCell>
                        <TableCell><b>Credits Awarded</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {pcsEventInstances?.slice().sort((a: PcsEventInstanceDto, b: PcsEventInstanceDto) =>
                            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
                        ).map((item: PcsEventInstanceDto) => (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">{getLocalDateInString(new Date(item.startDate))}</TableCell>
                                <TableCell>{item.description}</TableCell>
                                <TableCell>{item.credits}</TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
}
